import React, { FunctionComponent, useRef } from 'react'
import { Button } from '@cmsgov/design-system'
import { HHSLogo, MedicaregovLogo } from '@cmsgov/ds-medicare-gov'
import $ from 'jquery'
import { useTranslation } from 'react-i18next'
import { callPrivacySetting } from 'utils/privacy-settings'
import { LanguagePreference } from 'models/LanguagePreference'

// This is a custom version of the source code provided by cms: import { SimpleFooter } from '@cmsgov/ds-medicare-gov'

interface SimpleFooterProps {
  onClickLinkAnalytics?: (url: string) => void;
}

const SimpleFooter: FunctionComponent<SimpleFooterProps> = ({
  onClickLinkAnalytics
}) => {
  const footerRef = useRef<HTMLElement | any>()
  const { t, i18n } = useTranslation('common')
  const language = i18n.language as LanguagePreference
  // TODO: copy pasted from SimpleFooter element, should be updated to use blast/core analytics
  // useEffect(() => {
  //   if (onClickLinkAnalytics) {
  //     footerRef.current?.querySelectorAll('a').forEach((anchor: { onclick: () => void; href: string }) => {
  //       anchor.onclick = () => onClickLinkAnalytics(anchor.href)
  //     })
  //   }
  // }, [onClickLinkAnalytics])

  // @ts-ignore //added as a temporary fix or missing jquery while blast fixes the dep
  // this is essentially a bug fix for blast so they wont see missing jquery errors in the meantime (requested by ed)
  window.jQuery = $

  return (
    <footer className='m-c-footer' ref={footerRef}>
      <div className='m-c-footer__linkRow ds-u-visibility--hidden-print'>
        <div className='m-c-footer__links'>
          <a href='https://www.medicare.gov/about-us'>{t('footer.aboutMedicareLabel')}</a>
          <a href='https://www.medicare.gov/glossary/a'>
            {t('footer.medicareGlossaryLabel')}
          </a>
        </div>
        <div>
          <a href='https://www.medicare.gov/about-us/accessibility-nondiscrimination-notice'>
            {t('footer.nondiscriminationLabel')}
          </a>
          <a href='https://www.medicare.gov/privacy-policy'>
            {t('footer.privacyPolicyLabel')}
          </a>

          <Button
            className='SimpleFooter__linkButton'
            variation='ghost'
            data-testid='privacy-setting-button'
            // TODO: copy pasted from SimpleFooter element, should be updated to use blast/core analytics
            onClick={() => callPrivacySetting(language)}
          >
            {t('footer.privacySettingLabel')}
          </Button>

          <a href='https://www.cms.gov/About-CMS/Agency-Information/Aboutwebsite/index.html'>
            {t('footer.linkingPolicyLabel')}
          </a>
          <a href='https://www.medicare.gov/about-us/using-this-site'>
            {t('footer.usingThisSiteLabel')}
          </a>
          <a href='https://www.medicare.gov/about-us/plain-writing'>
            {t('footer.plainWritingLabel')}
          </a>
        </div>
      </div>
      <div className='m-c-footer__identityRow'>
        <MedicaregovLogo />
        <div className='m-c-footer__identityContent'>
          <HHSLogo />
          <span className='m-c-footer__contactAddress'>
            {t('footer.websiteInfo')}
            <br />
            7500 Security Boulevard, Baltimore, MD 21244
          </span>
        </div>
      </div>
    </footer>
  )
}

export default SimpleFooter
